import { render } from "./InfiniteLoadingLoader.vue?vue&type=template&id=1dc29413"
import script from "./InfiniteLoadingLoader.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingLoader.vue?vue&type=script&lang=js"

import "./InfiniteLoadingLoader.vue?vue&type=style&index=0&id=1dc29413&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__